import React from 'react';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import useGlobalState from 'actions';

const AppSnackbar = () => {
  const [globalState] = useGlobalState();
  return (
    <Snackbar
      open={globalState.isNotificationOpened}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <MuiAlert
        elevation={6}
        variant='filled'
        severity={globalState.notificationSeverity}
      >
        {globalState.notificationMessage}
      </MuiAlert>
    </Snackbar>
  );
};

export default AppSnackbar;
